/**
 *
 * @Copyright 2024 UNLOCK DECENTRALIZATION, LDA
 * Development by VOID Software, SA
 *
 */

export const CMD_PUBLIC_KEY = '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzK1MF/FXZ7OnaUCwAm+/\nyUfdJ0S40nntsJRsYXo5wZFSgiPm9WlooUFmBM6C518ailenaVPJo78SSwepBiGt\nNwf95jCU2+2PAR2uf5ZH5fSbkKZS84O5Kelskf+AQoeT555iSZTFWouC+tmMRcrt\nJHBhRh4nJ0iPnNQLv9q3s0NdMKqOcpCMbaDQIxfXZI9kcx4k8TvT/4NxBOrRTDFs\n9aojJZaVMb4iSbN2GHY1i3rPYo1JX0rtUS+eH/OSe1+HJQ6ybR98rqWdIRIMGgos\nYPYivbds8FkF60vyWvpEs2v0+qqgF+st/gGk7+eh0OzAsKFfb6kL7rAF5AtDvsX6\nOQIDAQAB\n-----END PUBLIC KEY-----\n';
